import _get from 'lodash/get';
import React from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Constants } from '@pwc/pwc-deals-web-common';
import featureFlags from 'common/helpers/featureFlags';
import authorizationService from '../../common/services/security/authorizationService';
import { structuredRoutes } from '../../common/services/urlService';
import EnableForProjectState from '../security/EnableForProjectState';
import ProjectPermissionRoute from '../security/ProjectPermissionRoute';
import { getManualRefreshEnabled } from '../project/projectSlice';
import AddAnalysisType from './AddAnalysisType/AddAnalysisType';
import AnalysesGroupsContainer from '../analysesGroups/components/AnalysesGroupsContainer/AnalysesGroupsContainer';
import AnalysisDetailScreenContainer from './AnalysesScreen/AnalysisDetailScreen/AnalysisDetailScreenContainer';
import AutoCreateFreeformAnalysis from './Freeform/CreateFreeformAnalysis/AutoCreateFreeformAnalysis.tsx';
import CreateFreeformAnalysis from './Freeform/CreateFreeformAnalysis/CreateFreeformAnalysis';
import EditFreeformAnalysis from './Freeform/EditFreeformAnalysis/EditFreeformAnalysis';
import DebtDebtLikeContainer from './structured-analysis/DebtDebtLike/DebtDebtLikeContainer/DebtDebtLikeContainer';
import DebtDebtLikeForm from './structured-analysis/DebtDebtLike/DebtDebtLikeForm/DebtDebtLikeForm';
import NetWorkingCapitalContainer from './structured-analysis/NetWorkingCapital/NetWorkingCapitalContainer/NetWorkingCapitalContainer';
import NetWorkingCapitalEditForm from './structured-analysis/NetWorkingCapital/NetWorkingCapitalEditForm/NetWorkingCapitalEditForm';
import QofEContainer from './structured-analysis/QofE/QofEContainer/QofEContainer';
import QofEEditForm from './structured-analysis/QofE/QofEEditForm/QofEEditForm';
import { RedirectV1V2 } from './structured-analysis/RedirectV1V2';
import { withStructuredContainer } from './structured-analysis/StructuredAnalysisContainer/StructuredAnalysisContainer';
import ReportPreview from '../../common/components/ReportPreview/ReportPreview';

const basePath = '/projects/:projectId/analyses/';

const qofEContainer = withStructuredContainer(QofEContainer);
const nwcContainer = withStructuredContainer(NetWorkingCapitalContainer);
const ddlContainer = withStructuredContainer(DebtDebtLikeContainer);

const ReportPreviewContainer = () => (
  <RedirectV1V2>
    <ReportPreview />
  </RedirectV1V2>
);

export const projectPermissionRoutes2 = [
  { path: 'add-type', component: AddAnalysisType },
  {
    path: 'create',
    exact: false,
    component: featureFlags.isAutoSaveEnabled
      ? AutoCreateFreeformAnalysis
      : CreateFreeformAnalysis,
  },
  {
    path: `${structuredRoutes[Constants.DEBT_AND_DEBT_LIKE]}/edit`,
    component: DebtDebtLikeForm,
  },
  {
    path: `${structuredRoutes[Constants.NET_WORKING_CAPITAL]}/edit`,
    component: NetWorkingCapitalEditForm,
  },
  {
    path: `${structuredRoutes[Constants.QUALITY_OF_EARNINGS]}/edit`,
    component: QofEEditForm,
  },
  { path: ':analysisId/edit', exact: false, component: EditFreeformAnalysis },
  {
    path: ':entityId/report-preview/:entityType(ANALYSIS)/:version(latest|shared)',
    exact: true,
    component: ReportPreviewContainer,
  },
];

export const routes2 = [
  {
    path: '',
    component: AnalysesGroupsContainer,
  },
  {
    path: structuredRoutes[Constants.NET_WORKING_CAPITAL],
    component: nwcContainer,
  },
  {
    path: structuredRoutes[Constants.QUALITY_OF_EARNINGS],
    component: qofEContainer,
  },
  {
    path: structuredRoutes[Constants.DEBT_AND_DEBT_LIKE],
    component: ddlContainer,
  },
  {
    path: ':analysisId/view',
    component: AnalysisDetailScreenContainer,
  },
];

const AnalysesContentRouter2 = () => {
  const isManualRefreshEnabled = useSelector(getManualRefreshEnabled);
  const { projectId } = useParams();
  const isAuthorized = (isProjectDisabled) => () =>
    !isProjectDisabled && authorizationService.hasValidToken();
  localStorage.setItem('isManualRefreshEnabled', isManualRefreshEnabled);
  return (
    <EnableForProjectState projectId={projectId}>
      {({ isProjectDisabled }) => (
        <Switch>
          {routes2.map((route) => (
            <Route
              key={route.path}
              exact={_get(route, 'exact', true)}
              path={`${basePath}${route.path}`}
              component={route.component}
            />
          ))}

          {projectPermissionRoutes2.map((route) => (
            <ProjectPermissionRoute
              key={route.path}
              exact={_get(route, 'exact', true)}
              permissions={[Constants.USER_PERMISSIONS.CONTRIBUTE]}
              isAuthorized={isAuthorized(isProjectDisabled)}
              path={`${basePath}${route.path}`}
              component={route.component}
              fallbackRoute={
                isProjectDisabled
                  ? basePath.replace(':projectId', projectId)
                  : '/'
              }
            />
          ))}

          <Route
            path={basePath}
            render={({ match }) => (
              <Redirect to={`/projects/${match.params.projectId}/analyses/`} />
            )}
          />
        </Switch>
      )}
    </EnableForProjectState>
  );
};

export default AnalysesContentRouter2;
